export default {
  apiBaseUrl: process.env.API_BASE_URL || 'https://api.conductor.dev.platform.cloudreach.com/api/',
  domain: 'cloudreach.auth0.com',
  authClientId: process.env.AUTH_CLIENT_ID || 'JceiWjKwCC68o0wzXM2zMXCOfsKQjB5v',
  docsUrl: 'https://docs.conductor.dev.platform.cloudreach.com/'
}
